module.exports = __webpack_public_path__ + "img/laboratorio2_4-3_1024.679417f0.webp";